import { Box, Flex, Grid, Skeleton } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { nFormatter } from 'src/utils/utils';

const LegendItem = ({ color, text, amount }: { color: string; text: string; amount: number }) => (
	<Grid
		templateColumns="32px auto"
		alignContent="center"
		gridGap="12px"
	>
		<Box
			boxSize="32px"
			borderRadius="3px"
			bg={color}
		/>
		<Flex
			flexDir="column"
			gap="6px"
		>
			<Box
				fontSize="12px"
				mt="-2px"
			>
				{text}
			</Box>
			<Box
				fontSize="16px"
				lineHeight="40%"
				fontWeight="bold"
			>
				{nFormatter(amount, 2)}
			</Box>
		</Flex>
	</Grid>
);

export const DistributionChart = ({
	creator,
	address,
	cartridgeContract,
	storeContract,
}: {
	creator: string;
	address: string;
	cartridgeContract: any;
	storeContract: any;
}) => {
	const { t } = useTranslation();

	const [isLoading, setLoading] = useState<boolean>(true);
	const [totalSupply, setTotalSupply] = useState<number>(0);
	const [ownerSupply, setOwnerSupply] = useState<number>(0);
	const [storeSupply, setStoreSupply] = useState<number>(0);

	useEffect(() => {
		(async () => {
			if (cartridgeContract && storeContract) {
				const total = await cartridgeContract.totalSupply();
				const store = await cartridgeContract.balanceOf(storeContract.address);
				const owner = await cartridgeContract.balanceOf(creator);

				setOwnerSupply(Number(owner) / 100);
				setTotalSupply(Number(total) / 100);
				setStoreSupply(Number(store) / 100);
				setLoading(false);
			}
		})();
	}, [cartridgeContract]);

	return (
		<>
			<Flex
				justifyContent="space-between"
				mb="47px"
				align="center"
			>
				<Grid
					templateColumns="repeat(3, 110px)"
					gridGap="20px"
				>
					<LegendItem
						color="#FF3F3F"
						text={t('yourGames.chart.gamers')}
						amount={totalSupply - storeSupply - ownerSupply}
					/>
					<LegendItem
						color="#BCBCBC"
						text={t('yourGames.chart.store')}
						amount={storeSupply}
					/>
					<LegendItem
						color="#393939"
						text={t('yourGames.chart.creator')}
						amount={ownerSupply}
					/>
				</Grid>
				<Grid
					gap="9px"
					alignItems="flex-end"
					textAlign="right"
				>
					<Box fontSize="12px">{t('yourGames.chart.totalSupply')}</Box>
					<Box
						fontSize="16px"
						lineHeight="40%"
						fontWeight="bold"
					>
						{totalSupply.toFixed(2)}
					</Box>
				</Grid>
			</Flex>
			{isLoading ? (
				<Skeleton
					h="16px"
					w="400px"
					opacity="0.5"
					bg="#393939"
				/>
			) : (
				<Grid
					templateColumns={`1fr ${(storeSupply / totalSupply) * 100}% ${(ownerSupply / totalSupply) * 100}% `}
					h="16px"
					bg="#393939"
				>
					<Box bg="#FF3F3F"></Box>
					<Box
						backgroundImage="linear-gradient(to right, #BCBCBC 50%, transparent 50%)"
						backgroundPosition="top"
						padding="1px 0px"
						backgroundSize="4px 16px"
						backgroundRepeat="repeat-x"
					></Box>
					<Box bg="#393939"></Box>
				</Grid>
			)}
		</>
	);
};
